<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Conta</h5>
                <hr>
                <TabView>					
                    <TabPanel header="Meus Dados" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-6">
                                <Panel header="Funcionário">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Nome:</h5>
                                            <label>{{ usuario.nome }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>E-mail:</h5>
                                            <label>{{ usuario.email }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Matrícula:</h5>
                                            <label>{{ usuario.matricula }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>PIS:</h5>
                                            <label>{{ fomatarPis(usuario.pis) }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>CPF:</h5>
                                            <label>{{ fomatarCpf(usuario.cpf) }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Cargo:</h5>
                                            <label>{{ usuario.cargo }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Centro de Custo:</h5>
                                            <label>{{ usuario.centroCusto }}</label>
                                        </div>
                                    </div>                                    
                                </Panel>
                            </div>
                            <div class="p-field p-col-12 p-md-6">
                                <Panel header="Empresa">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Empresa:</h5>
                                            <label>{{ empresa.razaoSocial }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>CNPJ:</h5>
                                            <label>{{ fomatarCnpj(empresa.cnpj) }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Endereço:</h5>
                                            <label>{{ empresa.endereco }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Estado:</h5>
                                            <label>{{ empresa.estado }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Cidade:</h5>
                                            <label>{{ empresa.cidade }}</label>
                                        </div>
                                        <div class="p-field p-md-6 p-col-12">
                                            <h5>Telefone:</h5>
                                            <label>{{ fomatarTelefone(empresa.telefone) }}</label>
                                        </div>  
                                        <div class="p-field p-md-12 p-col-12">
                                            <h5 style="color: #fff !important">.</h5>
                                            <label style="color: #fff !important">.</label>
                                        </div>                                                                                                                                                             
                                    </div> 
                                </Panel>
                            </div>                            
                        </div>                        
                    </TabPanel>
                    <TabPanel header="Senha" class="p-mt-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-md-4">
                                <label>Senha</label>
                                <Password v-model.trim="senha" :feedback="false"/>				
                            </div>                           
                        </div>
                        <div class="p-fluid p-formgrid p-grid">                           
                            <div class="p-field p-col-12 p-md-4">
                                <label>Repetir senha</label>
                                <Password v-model.trim="repetirSenha" :feedback="false"/>
                            </div>
                        </div>
                        <Button label="Salvar" icon="pi pi-check" class="p-mt-3" @click="alterarSenha"/>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>

<script>
import FuncionarioService from '@/service/FuncionarioService'; 
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    funcionarioService: null,
    data() {
        return {
            usuario: {},
            empresa: {},          
            senha: '',
            repetirSenha: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']), 
        /**
         * 
         */
        buscar() {
            let requisicao = {
                id: this.getUsuario().id,               
                tipoDispositivo: 'Web'
            }       
            this.funcionarioService.buscar(requisicao)
            .then(resp => {        
                this.usuario = resp.data.funcionario;
                this.empresa = resp.data.empresa;
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                } 
            });
        },
        /**
         * 
         */
        alterarSenha() {
            if(!this.senha || !this.repetirSenha) {
                exibirMensagemSis(this, 'Informe a senha e repetir senha', true);
                return;
            }
            let requisicao = {
                id: this.getUsuario().id,   
                cpfEmail: this.getUsuario().cpf,
                senha: this.senha,
                senhaRepetir: this.repetirSenha,            
                tipoDispositivo: 'Web'
            }       
            this.funcionarioService.alterarSenha(requisicao)
            .then(resp => {    
                this.senha = '';
                this.repetirSenha = '';  
                exibirMensagem(this, resp);
            })
            .catch(erro => {
                if(erro.response.status == 401) {
                    this.logout();
                } else {
                    exibirMensagem(this, erro)
                } 
            });
        },
        /**
         * 
         */
        fomatarCnpj(cnpj) {
            if(!cnpj) {
                return '';
            }
            let novo = '';
            let arrCnpj = cnpj.split('');
            if(arrCnpj.length > 0) {
                novo = arrCnpj[0]+arrCnpj[1];
                novo += '.'+arrCnpj[2]+arrCnpj[3]+arrCnpj[4];
                novo += '.'+arrCnpj[5]+arrCnpj[6]+arrCnpj[7];
                novo += '/'+arrCnpj[8]+arrCnpj[9]+arrCnpj[10]+arrCnpj[11];
                novo += '-'+arrCnpj[12]+arrCnpj[13];
            }
            return novo;
        },
        /**
         * 
         */
         fomatarCpf(cpf) {
            if(!cpf || cpf.length > 11) {
                return cpf;
            }
            let novo = '';
            let arrCpf = cpf.split('');
            if(arrCpf.length > 0) {
                novo = arrCpf[0]+arrCpf[1]+arrCpf[2];
                novo += '.'+arrCpf[3]+arrCpf[4]+arrCpf[5];
                novo += '.'+arrCpf[6]+arrCpf[7]+arrCpf[8];
                novo += '-'+arrCpf[9]+arrCpf[10];
            }
            return novo;
        },
        /**
         * 
         */
         fomatarPis(pis) {
            if(!pis || pis.length > 11) {
                return pis;
            }
            let novo = '';
            let arrPis = pis.split('');
            if(arrPis.length > 0) {
                novo = arrPis[0]+arrPis[1]+arrPis[2];
                novo += '.'+arrPis[3]+arrPis[4]+arrPis[5]+arrPis[6]+arrPis[7];
                novo += '.'+arrPis[8]+arrPis[9];
                novo += '-'+arrPis[10];
            }
            return novo;
        },
        /**
         * 
         */
         fomatarTelefone(telefone) {
            if(!telefone) {
                return '';
            }
            let novo = '';
            let arrTel = telefone.split('');
            if(arrTel.length > 0) {
                if(arrTel.length == 8) {
                    novo = arrTel[0]+arrTel[1]+arrTel[2]+arrTel[3];
                    novo += '-'+arrTel[4]+arrTel[5]+arrTel[6]+arrTel[7];
                } else if(arrTel.length == 9) {
                    novo = arrTel[0]+' '+arrTel[1]+arrTel[2]+arrTel[3]+arrTel[4];
                    novo += '-'+arrTel[5]+arrTel[6]+arrTel[7]+arrTel[8];                 
                } else if(arrTel.length == 10) {
                    novo = '('+arrTel[0]+arrTel[1]+') ';
                    novo += arrTel[2]+arrTel[3]+arrTel[4]+arrTel[5];
                    novo += '-'+arrTel[6]+arrTel[7]+arrTel[8]+arrTel[9];
                } else if(arrTel.length == 11) {
                    novo = '('+arrTel[0]+arrTel[1]+') ';
                    novo += arrTel[2]+' '+arrTel[3]+arrTel[4]+arrTel[5]+arrTel[6];
                    novo += '-'+arrTel[7]+arrTel[8]+arrTel[9]+arrTel[10];
                }                
            }
            return novo;
        },
        /**
         * 
         */
         logout() {
            this.limparSessao();			
            this.$router.push('/login');
        }
    },
    created() {
        this.funcionarioService = new FuncionarioService();
    },
    mounted() {
        this.buscar();
    }
}
</script>

<style>

</style>